import { ApiResponse, TokenData, Influencer } from '../models';
import * as http from './http';
import ApiService from './service';

export class InfluencerService extends ApiService {
  public async loadAllInfluencer() {
    const url = `${this.apiDomain}/api/influencer`;

    const resposne = await http.get<ApiResponse<Influencer[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateInfluencer(data: Influencer, id?: string) {
    const url = `${this.apiDomain}/api/influencer/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createInfluencer(data: Influencer) {
    const url = `${this.apiDomain}/api/influencer`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteInfluencer(id?: string) {
    const url = `${this.apiDomain}/api/influencer/${id}`;

    const response = await http.remove<ApiResponse<Influencer>>(
      url,
      this.store
    );
    return response.data;
  }
}
